import {computed, inject, Service} from '@angular/core'
import {StaticDataService} from '../services/static-data.service'

@Service()
export class Plural {
  protected staticDataService = inject(StaticDataService)

  protected plural = computed(() => this.staticDataService.plural())

  get plrDuNi(): string {
    return this.plural() ? 'Ni' : 'Du'
  }

  get plrDigEr(): string {
    return this.plural() ? 'er' : 'dig'
  }

  get plrDinaEra(): string {
    return this.plural() ? 'era' : 'dina'
  }

  get plrDinEr(): string {
    return this.plural() ? 'Er' : 'Din'
  }

  get plrBekvamBekvama(): string {
    return this.plural() ? 'bekväma' : 'bekväm'
  }

  get plrDittErt(): string {
    return this.plural() ? 'ert' : 'ditt'
  }

  get plrJagVi(): string {
    return this.plural() ? 'Vi' : 'Jag'
  }

  get plrMinaVara(): string {
    return this.plural() ? 'våra' : 'mina'
  }

  get plrMinVar(): string {
    return this.plural() ? 'vår' : 'min'
  }
}
